module.exports = __webpack_public_path__ + "img/9788954613040.66135072.jpg";